import { ValidationContextName } from '@interfaces/connector';

export const FOLDER_NAME_PATH_SEPARATOR = ': ';

export const VALIDATION_WARNING_GROUP_DESCRIPTIONS: Record<ValidationContextName, string> = {
  [ValidationContextName.DOCUMENTS_ROOT_FOLDER]: 'The root folder could not be reached:',
  [ValidationContextName.MAPPED_NETWORK_PATH]: 'The following drives could not be reached:',
};